/**
 * External links and URLs used throughout the application
 */
export const EXTERNAL_LINKS = {
    // Support and Help
    STRIPE_APPEAL_FORM: (userId: string | number) => `https://form.typeform.com/to/tCVtVzWh#user_id=${userId}`,
    PAYPAL_CONNECTION_HELP: 'https://help.stan.store/article/147-why-is-paypal-not-connecting-to-my-stan-store',
    STRIPE_PAYPAL_INTEGRATION_HELP: 'https://help.stan.store/article/258-how-to-integrate-stan-with-stripe-or-paypal',

    // External Services
    PAYPAL_MANAGE: 'https://paypal.com',

    // Internal Routes
    PAGE_CREATE_WITH_LOCATION: (location: string) => `/page/create?location=${location}`,
} as const;
